import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { DeleteOrgProductPayloadNetType, UpdateOrgProductsBodyNetType } from "./NetTypes";

async function editOrgProductsRequest({ orgId, products }: UpdateOrgProductsBodyNetType) {
	return await apiClient
		.post(API.COMMAND.ADMIN.CLIENT_PRODUCTS(orgId), products)
		.then((res) => res.data);
}

async function deleteOrgProductsRequest({ orgId, productId }: DeleteOrgProductPayloadNetType) {
	return await apiClient
		.delete(API.COMMAND.ADMIN.DELETE_CLIENT_PRODUCT(orgId, productId))
		.then((res) => res.data);
}

export function useEditOrgProducts() {
	return useMutation<any, AxiosError, UpdateOrgProductsBodyNetType>({
		mutationFn: (payload: UpdateOrgProductsBodyNetType) => editOrgProductsRequest(payload)
	});
}

export function useDeleteOrgProduct() {
	return useMutation<any, AxiosError, DeleteOrgProductPayloadNetType>({
		mutationFn: (payload: DeleteOrgProductPayloadNetType) => deleteOrgProductsRequest(payload)
	});
}
